// manikanta 12/23/2022 2700632669 changed  onMousePopOver FontSize
import React from 'react';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    // padding: theme.spacing(1),
    // maxWidth: "600px",
    overflowWrap: 'break-word',
  },
  typoFont: {
    fontSize: '12px',
    fontFamily: 'Robto-Regular',
    color: '#202020',
  },
  popOverFontSize: {
    fontSize: '10px !important',
    padding: '4px 7px !important',
    backgroundColor: 'grey',
    color: 'white',
    fontFamily: 'sans-serif',
  },
}));

export default function MouseOverPopover({data, popOverData, codeLength}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className="custom-comments">
      {codeLength ? (
        <Typography
          className={classes.typoFont}
          aria-owns={open ? 'mouse-over-popover' : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          {data?.substring(0, 9)} {data?.length >= 9 ? '...' : ''}
        </Typography>
      ) : (
        <Typography
          className={classes.typoFont}
          aria-owns={open ? 'mouse-over-popover' : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          {data}
        </Typography>
      )}

      <Popover
        id="mouse-over-popover"
        placement="left"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 20,
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <div className={classes.popOverFontSize}>{popOverData}</div>
      </Popover>
    </div>
  );
}
